module.exports = __webpack_public_path__ + "static/media/A_iko_2_EN.9ce1f855.svg";